module.exports = "<md-progress-linear class=\"progress-linear\" md-mode=\"indeterminate\" ng-show=\"$ctrl.isLoading()\"></md-progress-linear>";